import os from "@/modules/OS/pages/Index";
import osNova from "@/modules/OS/pages/Create";
import osTimeline from "@/modules/OS/pages/Timeline";

export default [
  {
    name: "ordensServicos",
    path: "/ordensServicos",
    component: os,
    meta: { title: "OS" },
  },
  {
    path: "/ordensServicos-nova",
    name: "ordensServicosNova",
    component: osNova,
    meta: { title: "OS" },
  },
  {
    path: "/ordensServicos-timeline/:id_ordem_servico",
    name: "ordensServicosTimeline",
    component: osTimeline,
    meta: { title: "Timeline OS" },
  },
];
